import React, { useState } from 'react';
import './Sidebar.css'; 
import { useAuth } from '../contexts/AuthContext'; 
import {jwtDecode} from 'jwt-decode';

const apiUrl = process.env.REACT_APP_API_URL;

// URLs diretas para as imagens no Google Drive
const historicoIcon = "https://i.imgur.com/vr8VDNy.png";
const localizacaoIcon = "https://i.imgur.com/mTwpEpT.png";

function Sidebar({ users, isOpen, onClose, onHistorico, onIrParaLocalizacao, empresaId }) {
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const { token } = useAuth(); 

  const handleAddViewer = () => {
    setModalTitle('Adicione mais Administradores');
    setShowModal(true);
  };

  const handleAddEmployee = () => {
    setModalTitle('Adicione mais Colaboradores');
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEmail('');
    setError('');
    setSuccess('');
  };

  const handleSubmit = async () => {
    if (!validateEmail(email)) {
      setError('Por favor, insira um email válido.');
      return;
    }
  
    try {
      const isAddingAdmin = modalTitle.includes('Administrador');
  
      if (isAddingAdmin) {
        const response = await fetch(`${apiUrl}admins/admin/email/${email}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
  
        if (response.status === 200) {
          const data = await response.json();
  
          const decodedToken = jwtDecode(token);
          const solicitanteId = decodedToken.id; // Obter o ID do solicitante do token decodificado
  
          if (solicitanteId === data.id) {
            setError('Você não pode enviar solicitação para você mesmo.');
            return;
          }
  
          const requestBody = {
            id_solicitante: solicitanteId,
            id_destinatario: data.id,
            id_empresa: empresaId
          };
  
          const requestResponse = await fetch(`${apiUrl}admins/solicitar-acesso-adm`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(requestBody)
          });
  
          const requestData = await requestResponse.json();
  
          if (requestResponse.status === 201) {
            setSuccess(requestData.message);
            setError('');
          } else if (requestResponse.status === 400 && requestData.message === 'O admin já faz parte desta empresa.') {
            setError(requestData.message);
            setSuccess('');
          } else {
            setError(requestData.error || 'Erro desconhecido.');
            setSuccess('');
          }
        } else {
          const errorData = await response.json();
          setError(errorData.error);
          setSuccess('');
        }
      } else {
        const requestBody = {
          emailFuncionario: email,
          idEmpresa: empresaId
        };
  
        const requestResponse = await fetch(`${apiUrl}admins/solicitar-localizacao`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(requestBody)
        });
  
        const requestData = await requestResponse.json();
  
        if (requestResponse.status === 200) {
          setSuccess(requestData.message);
          setError('');
        } else if (requestResponse.status === 400 && requestData.message === 'O funcionário já está vinculado a esta empresa.') {
          setError(requestData.message);
          setSuccess('');
        } else {
          setError(requestData.error || 'Erro desconhecido.');
          setSuccess('');
        }
      }
    } catch (error) {
      console.error('Erro ao verificar email:', error);
      setError('Erro ao verificar email.');
      setSuccess('');
    }
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  return (
    <div className={`sidebar ${isOpen ? 'open' : ''}`}>
      <button className="close-btn" onClick={onClose}>×</button>
      <h2>Funcionários Ativos</h2>
      <ul>
        {users.length > 0 ? (
          users.map(user => (
            <li key={user.id}>
              <span>{user.nome}</span>
              <button onClick={() => onHistorico(user.id)} className="icon-button" title="Histórico">
                <img src={historicoIcon} alt="Histórico" />
              </button>
              <button onClick={() => onIrParaLocalizacao(user.id)} className="icon-button" title="Ir para Localização">
                <img src={localizacaoIcon} alt="Ir para Localização" />
              </button>
            </li>
          ))
        ) : (
          <li>Nenhum funcionário ativo encontrado</li>
        )}
      </ul>
      <div className="sidebar-buttons">
        <button className="sidebar-button" onClick={handleAddViewer}>Adicione mais Administradores</button>
        <button className="sidebar-button" onClick={handleAddEmployee}>Adicione mais Colaboradores</button>
      </div>
      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={handleCloseModal}>&times;</span>
            <h2 className='titulo_modal'>{modalTitle}</h2>
            <p className='titulo_modal'>Digite o email</p>
            <input
              type="email"
              placeholder="exemplo@gmail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {error && <p className="error">{error}</p>}
            {success && <p className="success">{success}</p>}
            <button onClick={handleSubmit}>Enviar</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Sidebar;